import React from 'react'
import { arbcard } from '../../assets'
import styles, { layout } from '../../style'
import Button from './Button'

const CardDeal = () => {
  return (
    <section 
      className={layout.section}>
        <div className={layout.sectionInfo}>
          <h2 className={styles.heading2}>
            Are you on the wrong side of the Data Divide? <br className='sm:block hidden' />
          </h2>
          <p className={`${styles.paragraph} max-w-[470px] mt-5`}>
          Being different is required to earn a more significant share of your market, and elevate
          your company. Our solutions below focus on the areas needed to deliver on being different 
          in the new era of Data Ecosystems.
          </p>
          <Button styles="mt-10"/>
        </div>
        <div className={layout.sectionImg}>
          <img src={arbcard} alt="card" className='w-[100%] h-[100%]'/>
        </div>
      </section>
  )
}

export default CardDeal